import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import SummaryCard from './components/SummaryCard';
import { UserContext } from '../store/userContext';
import { ProductContext } from '../store/productContext';
import { SiteContext } from '../store/siteContext';
import { StorageContext } from '../store/storageContext';

const DashboardPage: React.FC = () => {
    const navigate = useNavigate();
    const { users, getUsers } = React.useContext(UserContext);
    const { products, getProducts } = React.useContext(ProductContext);
    const { sites, getSites } = React.useContext(SiteContext);
    const { storages, getStorages } = React.useContext(StorageContext);

    React.useEffect(() => {
        getUsers(true);
        getProducts(true);
        getSites(true);
        getStorages(true);
    }, [getUsers, getProducts, getSites, getStorages]);

    return (
        <Grid container
              rowSpacing={2}
              columnSpacing={2}
              sx={{ p: 4, width: '100%', mx: 'auto' }}
              justifyContent="center"
              alignItems="center">

            <Grid size={{ xs: 12, sm: 6, md: 4 }} display="flex" justifyContent="center">
                <SummaryCard
                    title="Users"
                    value={users.length}
                    onOpen={() => navigate('/users')}
                    icon={<path d="M44.4852 38.391C42.4124 38.391 40.6951 37.7077 39.3332 36.3412C37.9713 34.9742 37.2904 33.2634 37.2904 31.2087C37.2904 29.1359 37.9692 27.4142 39.3269 26.0435C40.6846 24.6723 42.3998 23.9867 44.4726 23.9867C46.5455 23.9867 48.2628 24.67 49.6247 26.0365C50.9865 27.4035 51.6675 29.1234 51.6675 31.1962C51.6675 33.2508 50.9886 34.9638 49.631 36.3349C48.2733 37.7056 46.558 38.391 44.4852 38.391ZM28.8023 54.2225V50.5019C28.8023 49.785 28.9759 49.1012 29.323 48.4508C29.6705 47.7998 30.1395 47.3294 30.73 47.0396C32.7344 45.694 34.9114 44.6785 37.2611 43.9932C39.6107 43.3078 42.0167 42.9651 44.4789 42.9651C46.9407 42.9651 49.3395 43.3336 51.6751 44.0706C54.0104 44.8081 56.2035 45.7978 58.2544 47.0396C58.7806 47.4332 59.2289 47.9294 59.5993 48.5282C59.9697 49.127 60.1548 49.785 60.1548 50.5019V54.2225H28.8023ZM9.60962 37.8752V34.7081H29.8387V37.8752H9.60962ZM9.60962 15.0317V11.8646H41.3599V15.0317H9.60962ZM33.1085 26.4406H9.60962V23.2727H34.8958C34.5092 23.7524 34.1637 24.2563 33.8594 24.7844C33.5556 25.312 33.3053 25.8641 33.1085 26.4406Z" fill="white"/>}
                />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }} display="flex" justifyContent="center">
                <SummaryCard
                    title="Products"
                    value={products.length}
                    onOpen={() => navigate('/products')}
                    icon={<path d="M5.15411 52.075V15.9983H10.5762V52.075H5.15411ZM12.8849 52.075V15.9983H18.0384V52.075H12.8849ZM20.6158 52.075V15.9983H23.1925V52.075H20.6158ZM28.3459 52.075V15.9983H33.5V52.075H28.3459ZM36.0767 52.075V15.9983H43.8075V52.075H36.0767ZM46.3842 52.075V15.9983H48.9616V52.075H46.3842ZM54.1151 52.075V15.9983H61.8459V52.075H54.1151Z" fill="white"/>}
                />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }} display="flex" justifyContent="center">
                <SummaryCard
                    title="Sites"
                    value={sites.length}
                    onOpen={() => navigate('/sites')}
                    icon={<path d="M33.5132 32.6143C34.7644 32.6143 35.831 32.1688 36.7132 31.2778C37.5953 30.3868 38.0364 29.3157 38.0364 28.0646C38.0364 26.8135 37.5909 25.7468 36.6999 24.8647C35.8089 23.9825 34.7378 23.5414 33.4867 23.5414C32.2356 23.5414 31.1689 23.9869 30.2868 24.8779C29.4046 25.7689 28.9635 26.84 28.9635 28.0911C28.9635 29.3418 29.409 30.4085 30.3 31.2911C31.191 32.1733 32.2621 32.6143 33.5132 32.6143ZM33.5 55.8494C39.3304 50.649 43.7719 45.6903 46.8246 40.9733C49.8777 36.2558 51.4043 32.1344 51.4043 28.609C51.4043 23.2211 49.693 18.7926 46.2704 15.3234C42.8479 11.8543 38.591 10.1198 33.5 10.1198C28.4089 10.1198 24.1521 11.8543 20.7295 15.3234C17.3069 18.7926 15.5956 23.2211 15.5956 28.609C15.5956 32.1344 17.148 36.2558 20.2528 40.9733C23.3576 45.6903 27.7733 50.649 33.5 55.8494ZM33.5 60.0474C26.4743 53.9597 21.2059 48.2942 17.6949 43.051C14.184 37.8073 12.4285 32.9933 12.4285 28.609C12.4285 22.1668 14.5122 16.9512 18.6797 12.9624C22.8477 8.97357 27.7878 6.97916 33.5 6.97916C39.2122 6.97916 44.1523 8.97357 48.3202 12.9624C52.4877 16.9512 54.5715 22.1668 54.5715 28.609C54.5715 32.9933 52.816 37.8073 49.305 43.051C45.794 48.2942 40.5257 53.9597 33.5 60.0474Z" fill="white"/>}
                />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }} display="flex" justifyContent="center">
                <SummaryCard
                    title="Storages"
                    value={storages.length}
                    accentColor="#4C4D4F"
                    icon={<path d="M9.77081 62.9465V4.08002H12.9387V9.79805H54.0613V4.08002H57.2291V62.9465H54.0613V57.2292H12.9387V62.9465H9.77081ZM12.9387 31.2611H20.911V20.4168H34.9223V31.2611H54.0613V12.9652H12.9387V31.2611ZM12.9387 54.0613H32.0776V43.2171H46.089V54.0613H54.0613V34.4289H12.9387V54.0613Z" fill="white"/>}
                />
            </Grid>
        </Grid>
    );
};

export default DashboardPage;
